/* ============================================================
   Dietking Herbal Theme — theme.js (v4)
   ============================================================ */

(function () {
  'use strict';

  /* --------------------------------------------------------
     Best Sellers Carousel (v2)
     Real scroll-snap carousel with arrow controls + swipe
  -------------------------------------------------------- */
  function initBsCarousel() {
    var carousel = document.getElementById('bsCarousel');
    var prevBtn  = document.getElementById('bsPrev');
    var nextBtn  = document.getElementById('bsNext');

    if (!carousel) return;

    /* Calculate one slide width (including gap) */
    function slideWidth() {
      var slide = carousel.querySelector('.bs-slide');
      if (!slide) return 300;
      var gap = parseInt(getComputedStyle(carousel).columnGap) || 24;
      return slide.offsetWidth + gap;
    }

    function scrollBySlides(count) {
      carousel.scrollBy({ left: slideWidth() * count, behavior: 'smooth' });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var atStart = carousel.scrollLeft <= 4;
      var atEnd   = carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth - 4;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollBySlides(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollBySlides(1); });

    carousel.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    /* Touch / swipe */
    var tsX = 0;
    carousel.addEventListener('touchstart', function (e) {
      tsX = e.changedTouches[0].clientX;
    }, { passive: true });

    carousel.addEventListener('touchend', function (e) {
      var diff = tsX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) scrollBySlides(diff > 0 ? 1 : -1);
    }, { passive: true });

    /* Keyboard arrow support when carousel is focused */
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { scrollBySlides(1); e.preventDefault(); }
      if (e.key === 'ArrowLeft')  { scrollBySlides(-1); e.preventDefault(); }
    });
  }

  /* --------------------------------------------------------
     Product Card Variant Selection
  -------------------------------------------------------- */
  function initVariantSelectors() {
    var selectors = document.querySelectorAll('[data-variant-selector]');
    if (!selectors.length) return;

    selectors.forEach(function(selector) {
      var productId = selector.dataset.productId;
      var pills = selector.querySelectorAll('.variant-pill');
      
      if (!pills.length) return;

      pills.forEach(function(pill) {
        var radio = pill.querySelector('input[type="radio"]');
        if (!radio) return;

        // Handle click on label/pill
        pill.addEventListener('click', function(e) {
          if (pill.classList.contains('variant-pill--sold-out')) {
            e.preventDefault();
            return;
          }

          // Update active state visually
          pills.forEach(function(p) {
            p.classList.remove('variant-pill--active');
            p.querySelector('input[type="radio"]').checked = false;
          });
          pill.classList.add('variant-pill--active');
          radio.checked = true;

          // Update form values
          var card = selector.closest('.product-card');
          if (!card) return;

          var variantInput = card.querySelector('[data-variant-id-input]');
          var priceEl = card.querySelector('[data-product-card-price]');
          var comparePriceEl = card.querySelector('[data-product-card-compare-price]');
          var priceRow = card.querySelector('[data-product-card-price-row]');

          // Update hidden variant ID
          if (variantInput) {
            variantInput.value = radio.value;
          }

          // Update price display
          var newPrice = pill.dataset.variantPrice;
          var newComparePrice = pill.dataset.variantComparePrice;
          var isAvailable = pill.dataset.variantAvailable === 'true';

          if (priceEl && newPrice) {
            priceEl.textContent = newPrice;
            
            // Handle sale pricing
            if (newComparePrice && comparePriceEl) {
              comparePriceEl.textContent = newComparePrice;
              comparePriceEl.style.display = 'inline';
              priceEl.classList.add('product-price--sale');
            } else if (comparePriceEl) {
              comparePriceEl.style.display = 'none';
              priceEl.classList.remove('product-price--sale');
            }
          }

          // Update add to cart button state
          var atcBtn = card.querySelector('.btn-atc');
          if (atcBtn) {
            atcBtn.disabled = !isAvailable;
            if (isAvailable) {
              atcBtn.innerHTML = '<i class="fas fa-shopping-cart"></i> Add to Cart';
            } else {
              atcBtn.innerHTML = '<i class="fas fa-times-circle"></i> Sold Out';
            }
          }

          // Optional: Animate price change
          if (priceRow) {
            priceRow.style.transition = 'transform 0.2s ease';
            priceRow.style.transform = 'scale(1.02)';
            setTimeout(function() {
              priceRow.style.transform = 'scale(1)';
            }, 200);
          }
        });
      });
    });
  }

  /* --------------------------------------------------------
     CART DRAWER — open / close / render
  -------------------------------------------------------- */
  function openCartDrawer() {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }

  function closeCartDrawer() {
    var drawer  = document.getElementById('cartDrawer');
    var overlay = document.getElementById('cartDrawerOverlay');
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function formatMoney(cents) {
    return '\u20b9' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function triggerCartAnimation() {
    var icons = [
      document.getElementById('cartIconBtn'),
      document.getElementById('stickyCartBtn')
    ];
    var badges = [
      document.getElementById('cart-badge'),
      document.getElementById('stickyCartBadge')
    ];
    icons.forEach(function(el) {
      if (!el) return;
      el.classList.remove('cart-icon-animate');
      void el.offsetWidth;
      el.classList.add('cart-icon-animate');
      el.addEventListener('animationend', function() {
        el.classList.remove('cart-icon-animate');
      }, { once: true });
    });
    badges.forEach(function(el) {
      if (!el) return;
      el.classList.remove('badge-animate');
      void el.offsetWidth;
      el.classList.add('badge-animate');
      el.addEventListener('animationend', function() {
        el.classList.remove('badge-animate');
      }, { once: true });
    });
  }

  function showCartToast(message, type) {
    var existing = document.querySelector('.cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'cart-toast cart-toast--' + (type || 'update');
    var icon = type === 'add' ? 'fa-check-circle' : type === 'remove' ? 'fa-trash-alt' : 'fa-sync-alt';
    toast.innerHTML = '<i class="fas ' + icon + '"></i> ' + message;
    document.body.appendChild(toast);
    setTimeout(function () {
      toast.classList.add('is-removing');
      setTimeout(function () { toast.remove(); }, 300);
    }, 2200);
  }

  function renderCartDrawer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);

        var countEl    = document.getElementById('drawerCartCount');
        var itemsEl    = document.getElementById('cartDrawerItems');
        var emptyEl    = document.getElementById('cartDrawerEmpty');
        var footEl     = document.getElementById('cartDrawerFoot');
        var subtotalEl = document.getElementById('drawerSubtotal');

        if (countEl) countEl.textContent = cart.item_count;

        if (cart.item_count === 0) {
          if (itemsEl) itemsEl.innerHTML = '';
          if (emptyEl) emptyEl.style.display = 'flex';
          if (footEl)  footEl.style.display  = 'none';
          hideYmal();
          return;
        }

        if (emptyEl) emptyEl.style.display = 'none';
        if (footEl)  footEl.style.display  = 'block';
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        var html = '';
        cart.items.forEach(function (item, index) {
          var lineIndex = index + 1;
          var variantInfo = item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="cart-item__variant">' + item.variant_title + '</span>' : '';
          var imgSrc = item.image ? (item.image.startsWith('//') ? 'https:' + item.image : item.image) : '';
          html += '<div class="cart-item" data-line="' + lineIndex + '">' +
            '<div class="cart-item__img-wrap">' +
              (imgSrc ? '<img class="cart-item__img" src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
            '</div>' +
            '<div class="cart-item__details">' +
              '<span class="cart-item__title">' + item.product_title + '</span>' +
              variantInfo +
              '<div class="cart-item__price-row">' +
                '<span class="cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
                '<div class="cart-item__qty-wrap">' +
                  '<button class="cart-item__qty-btn" data-line="' + lineIndex + '" data-qty="' + item.quantity + '" data-action="minus">&#8722;</button>' +
                  '<span class="cart-item__qty-num">' + item.quantity + '</span>' +
                  '<button class="cart-item__qty-btn" data-line="' + lineIndex + '" data-qty="' + item.quantity + '" data-action="plus">+</button>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<button class="cart-item__remove" data-line="' + lineIndex + '" aria-label="Remove"><i class="fas fa-trash-alt" style="pointer-events:none"></i></button>' +
          '</div>';
        });
        if (itemsEl) itemsEl.innerHTML = html;

        loadYmal(cart.items);
      });
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('cart-badge');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  function hideYmal() {
    var ymal = document.getElementById('cartYmal');
    if (ymal) ymal.classList.add('is-hidden');
  }

  function loadYmal(cartItems) {
    var ymal     = document.getElementById('cartYmal');
    var ymalList = document.getElementById('cartYmalList');
    if (!ymal || !ymalList) return;

    var cartProductIds = cartItems.map(function (i) { return i.product_id; });
    var collectionHandle = 'all';

    fetch('/collections/' + collectionHandle + '/products.json?limit=8', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return cartProductIds.indexOf(p.id) === -1;
        }).slice(0, 3);

        if (products.length === 0) { hideYmal(); return; }

        ymal.classList.remove('is-hidden');
        var html = '';
        products.forEach(function (p) {
          var variant  = p.variants.find(function(v) { return v.available; }) || p.variants[0];
          var rawImg   = p.images[0] ? p.images[0].src : '';
          var imgSrc   = rawImg ? (rawImg.startsWith('//') ? 'https:' + rawImg : rawImg) : '';
          var price    = '₹' + parseFloat(variant.price).toFixed(2).replace(/\.00$/, '');
          html += '<div class="ymal-card">' +
            '<a href="/products/' + p.handle + '">' +
              '<div class="ymal-card__img-wrap">' +
                '<img class="ymal-card__img" src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">' +
              '</div>' +
            '</a>' +
            '<div class="ymal-card__info">' +
              '<span class="ymal-card__title">' + p.title + '</span>' +
              '<span class="ymal-card__price">' + price + '</span>' +
              '<button class="ymal-card__atc" data-ymal-variant="' + variant.id + '">' +
                '<i class="fas fa-shopping-cart"></i> Add to Cart' +
              '</button>' +
            '</div>' +
          '</div>';
        });
        ymalList.innerHTML = html;
      })
      .catch(function () { hideYmal(); });
  }

  function initCartDrawer() {
    var closeBtn = document.getElementById('cartDrawerClose');
    var overlay  = document.getElementById('cartDrawerOverlay');
    var cartIcon = document.getElementById('cartIconBtn');

    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (overlay)  overlay.addEventListener('click', closeCartDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        openCartDrawer();
      });
    }

    /* Discount coupon apply */
    var couponApply = document.getElementById('drawerCouponApply');
    if (couponApply) {
      couponApply.addEventListener('click', function () {
        var input   = document.getElementById('drawerCouponInput');
        var msgEl   = document.getElementById('drawerCouponMsg');
        var code    = input ? input.value.trim() : '';
        if (!code) return;
        msgEl.className = 'cart-drawer__discount-msg';
        msgEl.textContent = 'Applying...';
        fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'follow' })
          .then(function (r) {
            if (r.ok || r.redirected) {
              msgEl.className = 'cart-drawer__discount-msg is-success';
              msgEl.textContent = '✓ Coupon applied!';
            } else {
              msgEl.className = 'cart-drawer__discount-msg is-error';
              msgEl.textContent = '✗ Invalid coupon code.';
            }
          })
          .catch(function () {
            msgEl.className = 'cart-drawer__discount-msg is-error';
            msgEl.textContent = '✗ Could not apply. Try at checkout.';
          });
      });
    }

    /* Qty change & remove inside drawer */
    document.addEventListener('click', function (e) {
      /* Qty +/- */
      var qtyBtn = e.target.closest('.cart-item__qty-btn');
      if (qtyBtn) {
        var line   = parseInt(qtyBtn.dataset.line, 10);
        var action = qtyBtn.dataset.action;
        var qty    = parseInt(qtyBtn.dataset.qty, 10) || 1;
        var newQty = action === 'plus' ? qty + 1 : Math.max(0, qty - 1);
        qtyBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        }).then(function (r) { return r.json(); })
          .then(function () { triggerCartAnimation(); showCartToast(newQty === 0 ? 'Item removed from cart' : 'Quantity updated', newQty === 0 ? 'remove' : 'update'); renderCartDrawer(); })
          .catch(function () { renderCartDrawer(); });
        return;
      }

      /* Remove */
      var removeBtn = e.target.closest('.cart-item__remove');
      if (removeBtn) {
        var line = parseInt(removeBtn.dataset.line, 10);
        removeBtn.disabled = true;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        }).then(function (r) { return r.json(); })
          .then(function () { triggerCartAnimation(); showCartToast('Item removed from cart', 'remove'); renderCartDrawer(); })
          .catch(function () { renderCartDrawer(); });
        return;
      }

      /* YMAL Add to Cart */
      var ymalBtn = e.target.closest('.ymal-card__atc');
      if (ymalBtn) {
        var variantId = ymalBtn.dataset.ymalVariant;
        var origHTML  = ymalBtn.innerHTML;
        ymalBtn.disabled = true;
        ymalBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        }).then(function () {
          ymalBtn.innerHTML = '<i class="fas fa-check"></i> Added!';
          triggerCartAnimation(); showCartToast('Added to cart!', 'add'); renderCartDrawer();
          setTimeout(function () {
            ymalBtn.innerHTML = origHTML;
            ymalBtn.disabled = false;
          }, 1800);
        }).catch(function () {
          ymalBtn.innerHTML = origHTML;
          ymalBtn.disabled = false;
        });
      }
    });
  }

  /* --------------------------------------------------------
     Add to Cart — AJAX with visual feedback + open drawer
  -------------------------------------------------------- */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('product-card-form')) return;

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;

      var variantInput = form.querySelector('[data-variant-id-input]') || form.querySelector('input[name="id"]');
      var variantId = variantInput ? variantInput.value : '';

      if (!variantId) return;

      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            btn.innerHTML = '<i class="fas fa-exclamation-circle"></i> Error';
            setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 1800);
          } else {
            btn.innerHTML = '<i class="fas fa-check"></i> Added!';
            triggerCartAnimation();
            showCartToast('Added to cart!', 'add');
            openCartDrawer();
            setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 1800);
          }
        })
        .catch(function () {
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        });
    });
  }

  /* --------------------------------------------------------
     Cart count badge (initial load)
  -------------------------------------------------------- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
      });
  }

  /* --------------------------------------------------------
     Sticky header shadow on scroll
  -------------------------------------------------------- */
  function initHeaderScroll() {
    /* Header is static — scroll handled by initStickyBar */
  }

  /* --------------------------------------------------------
     Sticky bar — slides down from top after 50px scroll
  -------------------------------------------------------- */
  function initStickyBar() {
    var bar = document.getElementById('stickyBar');
    if (!bar) return;

    /* Show/hide on scroll */
    window.addEventListener('scroll', function () {
      if (window.scrollY > 80) {
        bar.classList.add('is-visible');
        bar.removeAttribute('aria-hidden');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      }
    }, { passive: true });

    /* Sticky hamburger opens the same mobile menu */
    var stickyHam = document.getElementById('stickyHamburger');
    var mainHam   = document.getElementById('hamburgerBtn');
    if (stickyHam && mainHam) {
      stickyHam.addEventListener('click', function () {
        mainHam.click();
      });
    }

    /* Sticky cart icon opens cart drawer */
    var stickyCart = document.getElementById('stickyCartBtn');
    var mainCart   = document.getElementById('cartIconBtn');
    if (stickyCart && mainCart) {
      stickyCart.addEventListener('click', function (e) {
        e.preventDefault();
        mainCart.click();
      });
    }

    /* Keep sticky cart badge in sync */
    var mainBadge   = document.getElementById('cart-badge');
    var stickyBadge = document.getElementById('stickyCartBadge');
    if (mainBadge && stickyBadge) {
      function syncBadge() {
        var count = mainBadge.textContent.trim();
        if (count && count !== '0' && mainBadge.style.display !== 'none') {
          stickyBadge.textContent = count;
          stickyBadge.style.display = 'flex';
        } else {
          stickyBadge.style.display = 'none';
        }
      }
      syncBadge();
      var observer = new MutationObserver(syncBadge);
      observer.observe(mainBadge, { childList: true, characterData: true, subtree: true });
    }
  }

  /* --------------------------------------------------------
     Lazy card reveal (IntersectionObserver)
  -------------------------------------------------------- */
  function initLazyReveal() {
    if (!('IntersectionObserver' in window)) return;
    var cards = document.querySelectorAll('.product-card, .bundle-card, .cat-circle');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    cards.forEach(function (card) {
      card.classList.add('fade-in-ready');
      observer.observe(card);
    });
  }

  /* --------------------------------------------------------
     Shopify Section Reload Support
  -------------------------------------------------------- */
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function(event) {
      initVariantSelectors();
      initAddToCart();
    });
    document.addEventListener('shopify:section:select', function(event) {
      initVariantSelectors();
    });
  }

  /* --------------------------------------------------------
     Banner Slider
  -------------------------------------------------------- */
  function initBannerSliders() {
    var sliders = document.querySelectorAll('.banner-slider');
    sliders.forEach(function (slider) {
      var slides   = slider.querySelectorAll('.banner-slider__slide');
      var dots     = slider.querySelectorAll('.banner-slider__dot');
      var prevBtn  = slider.querySelector('.banner-slider__arrow--prev');
      var nextBtn  = slider.querySelector('.banner-slider__arrow--next');
      var total    = slides.length;
      if (total < 2) return;

      var current  = 0;
      var autoplay = slider.dataset.autoplay === 'true';
      var speed    = parseInt(slider.dataset.speed, 10) || 4000;
      var timer    = null;

      function goTo(index) {
        if (index === current) return;
        var prev = current;
        current  = (index + total) % total;

        slides[prev].classList.remove('is-active');
        slides[prev].classList.add('is-leaving');
        slides[current].classList.add('is-active');

        setTimeout(function () {
          slides[prev].classList.remove('is-leaving');
        }, 850);

        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      function startTimer() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(next, speed);
      }

      function resetTimer() {
        clearInterval(timer);
        startTimer();
      }

      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetTimer(); });
      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetTimer(); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); resetTimer(); });
      });

      /* Pause on hover */
      slider.addEventListener('mouseenter', function () { clearInterval(timer); });
      slider.addEventListener('mouseleave', startTimer);

      /* Touch/swipe support */
      var touchStartX = 0;
      slider.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      slider.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          diff > 0 ? next() : prev();
          resetTimer();
        }
      }, { passive: true });

      startTimer();
    });
  }

  /* --------------------------------------------------------
     Mobile Left Menu
  -------------------------------------------------------- */
  function initMobileMenu() {
    var hamburger = document.getElementById('hamburgerBtn');
    var menu      = document.getElementById('mobileMenu');
    var overlay   = document.getElementById('mobileMenuOverlay');
    var closeBtn  = document.getElementById('mobileMenuClose');

    if (!hamburger || !menu || !overlay) return;

    function openMenu() {
      menu.classList.add('is-open');
      overlay.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      overlay.setAttribute('aria-hidden', 'false');
      hamburger.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      overlay.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });

    /* Expandable sub-menu toggle — smooth CSS animation */
    var expandBtns = menu.querySelectorAll('.mobile-menu__expand-btn');
    expandBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub    = btn.nextElementSibling;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        /* Close all others */
        expandBtns.forEach(function (b) {
          b.setAttribute('aria-expanded', 'false');
          var s = b.nextElementSibling;
          if (s) s.classList.remove('is-open');
        });
        /* Toggle current */
        if (!isOpen && sub) {
          btn.setAttribute('aria-expanded', 'true');
          sub.classList.add('is-open');
        }
      });
    });
  }

  /* --------------------------------------------------------
     Announcement Bar — close & remember
  -------------------------------------------------------- */
  function initAnnouncementBar() {
    var bar      = document.getElementById('announcementBar');
    var closeBtn = document.getElementById('announcementClose');
    if (!bar || !closeBtn) return;

    if (sessionStorage.getItem('annBarClosed') === '1') {
      bar.classList.add('is-hidden');
      return;
    }

    closeBtn.addEventListener('click', function () {
      bar.classList.add('is-hidden');
      sessionStorage.setItem('annBarClosed', '1');
    });
  }

  /* --------------------------------------------------------
     Init
  -------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initBsCarousel();
    initBannerSliders();
    initVariantSelectors();
    initAddToCart();
    initCartDrawer();
    initMobileMenu();
    initAnnouncementBar();
    initHeaderScroll();
    initStickyBar();
    initLazyReveal();
    updateCartCount();
  });

})();
